import React, { useState } from 'react'
import styled, { css } from 'styled-components'

import { Button } from '../Button'
import { Image } from '../Image'
import { breakpoint, themeColor, themeSpace } from '../theme'

export interface NeedHelpProps {
  text: string
  phone: string
  icon: React.ReactNode
}

const NeedHelpContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${breakpoint.tablet(css`
    width: 200px;
  `)}
`

const NeedHelpButton = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;

  color: white;
  font-weight: bold;
  cursor: pointer;
  border-top-left-radius: 4px;

  background: ${themeColor('pumpkinOrange')};

  & > img {
    margin-right: ${themeSpace(2)};
  }
`

const NeedHelpExpandArea = styled.div<{ open: boolean }>`
  overflow: hidden;
  max-height: ${({ open }) => (open ? '450px' : '0')};
  transition: max-height 0.7s ease-out;
  background: ${themeColor('bgPrimary')};
`

const ExpandAreaContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${themeSpace(1)};
`

const HelpText = styled.div`
  display: flex;
  justify-content: center;
`

const Icon = styled.div`
  margin-right: ${themeSpace(2)};
  font-size: 3em;
  color: ${themeColor('primary')};
`

const HelpCall = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${themeSpace(2)};
`

const HelpNumber = styled.span`
  font-weight: bold;
  margin-bottom: ${themeSpace(2)};
`

export const NeedHelp = ({ text, phone, icon }: NeedHelpProps) => {
  const [open, setOpen] = useState(false)

  return (
    <NeedHelpContainer>
      <NeedHelpButton onClick={() => setOpen(o => !o)}>
        <Image type={open ? 'down' : 'up'} />
        Need help ?
      </NeedHelpButton>
      <NeedHelpExpandArea open={open}>
        <ExpandAreaContent>
          <HelpText>
            <Icon>{icon}</Icon>
            {text}
          </HelpText>
          <HelpCall>
            <HelpNumber>{phone}</HelpNumber>
            <a href={`tel:${phone}`}>
              <Button size="large" variant="primary">
                Call
              </Button>
            </a>
          </HelpCall>
        </ExpandAreaContent>
      </NeedHelpExpandArea>
    </NeedHelpContainer>
  )
}
